import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class AuthStocktakingIndexRoute extends Route {
  @service store;
  @service declare router: RouterService;
  model() {
    // weiterleiten auf erste
    const model = this.store.peekAll('location');
    return this.router.transitionTo('auth.stocktaking.name', model[0].name);
  }
}
